(function() {
    "use strict";

    const ko = require('knockout');
    const $ = require('jquery');
    const Sortable = require('sortablejs');
    const koSortable = require('knockout-sortablejs');
    const koQuill = require('../components/ko.quill');
    const koModal = require('../components/ko.modal');
    const koTypeahead = require('../bindings/ko.typeahead');
    const bootstrapToggle = require('../bindings/ko.bootstrapToggle');
    const ezBSAlert = require('../utils/ezBSAlert');

    class EditChapterViewModel {
        constructor(data) {
            this.id = data.id;
            this.roleplay = data.roleplay;
            this.title = ko.observable(data.title || '');
            this.description = ko.observable(data.description || '{}');
            this.author = ko.observable(data.author || '');
            this.isPrivate = ko.observable(data.isPrivate || false);
            this.characters = ko.observableArray([]);
            this.versions = ko.observableArray(data.descriptionVersions || []);
            this.historyOpen = ko.observable(false);
            this.searchCharacters = function(query, syncResults) {
                let exclusions = this.characters().map(item => {
                    return item.id;
                });

                if (exclusions.length === 0)
                    exclusions = [0];

                $.ajax('/api/search/characters?query=' + query + '&exclude=' + JSON.stringify(exclusions), {
                    method: 'get',
                    success: data => {
                        syncResults(data);
                    }
                });
            }.bind(this);
            this.removeCharacter = function(event, context) {
                if (Sortable.utils.is(event.target, ".drag-remove")) {
                    event.item.parentNode.removeChild(event.item);
                    this.characters.remove(character => {
                        return character.id === context.id;
                    });
                }
            }.bind(this);
            this.setVersion = function(item) {
                this.description({
                    replace: true,
                    value: item.value
                });
            }.bind(this);
        }

        load() {
            if (this.id) {
                $.ajax('/api/search/characters?chapter=' + this.id, {
                    method: 'get',
                    success: data => {
                        this.characters(data);
                    }
                });
            }
        }

        save() {
            if (!this.characters().length) {
                ezBSAlert({
                    messageText: "Vous devez ajouter au moins un participant.",
                    alertType: "danger",
                    modalSize: "modal-sm"
                });
                return;
            }

            if (this.id) {
                $.ajax('/api/chapter/' + this.id, {
                    method: 'put',
                    data: {
                        id: this.id,
                        title: this.title(),
                        description: this.description(),
                        private: this.isPrivate(),
                        characters: JSON.stringify(this.characters())
                    },
                    success: data => {
                        if (data.success) {
                            window.location.href = '/roleplay/' + this.roleplay + '/chapter/' + this.id;
                        }
                    }
                });
            } else {
                $.ajax('/api/chapter', {
                    method: 'post',
                    data: {
                        title: this.title(),
                        description: this.description(),
                        roleplay: this.roleplay,
                        private: this.isPrivate(),
                        characters: JSON.stringify(this.characters())
                    },
                    success: data => {
                        if (data.success) {
                            window.location.href = '/roleplay/' + this.roleplay + '/chapter/' + data.id;
                        }
                    }
                });
            }
        }
    }

    module.exports = EditChapterViewModel;
})();


// WEBPACK FOOTER //
// ./resources/scripts/viewmodels/editChapterViewModel.js